export const floatingInvCustomStyles = {
  'overlay': {
    'background': 'rgba(0, 0, 0, 0.6)',
  },
  'content': {
    'left': '2%',
    'width': '96%',
    'height': 'auto',
    'padding': '0px',
    'display': 'flex',
    'flexDirection': 'column',
    'justifyContent': 'center',
    'backgroundColor': 'transparent',
    'margin': '0px',
    'border': '0px',
    'overflowY': 'hidden !important',
  },
};
